import * as React from 'react';
import {RouteComponentProps, withRouter} from 'react-router-dom';
import RecordsTableViewHeader from './RecordsTableViewHeader';
import {SUB_DIR} from '../../Config/appConfig';

interface NoRecordsProps {
    page: string
}

class NoRecords extends React.Component <RouteComponentProps & NoRecordsProps, {}> {
    public render() {
        return (
            <div className="recordsTableViewContainer">
                <RecordsTableViewHeader page={this.props.page}/>
                <div className="cmText noRecordsInfo">{`No records${this.props.history.location.pathname.split('/')[2] === SUB_DIR.ARCHIVED ? "." : ", create a record to kick start."}`}</div>
            </div>
        );
    }
}

export default withRouter(NoRecords);


// WEBPACK FOOTER //
// ./src/Components/Records/NoRecords.tsx